module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('a', {
    attrs: {
      "id": "epigraph_1"
    }
  }), _c('p', {
    staticClass: "ep"
  }, [_c('em', [_vm._v("The risk it takes to remain tight inside the bud"), _c('br'), _vm._v("is more painful than the risk it takes to blossom.")])]), _c('p', {
    staticClass: "eps"
  }, [_vm._v("—A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NAïS")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IN")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63152a24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Conversationsw_epig_1.vue
// module id = 75
// module chunks = 0